import useSWR from "swr";
import { fetchWithCSRF } from "@/helpers/common/csrf";

const API_URL = import.meta.env.VITE_VANDERHEIM_NINJA_API_URL;
const fetcher = (url: string) => fetchWithCSRF(url).then((res) => res.json());

export function useAuxiliaryData() {
    const { data: clans, isLoading: loadingClans } = useSWR(
        `${API_URL}/longhouse-api/village/clans/`,
        fetcher,
    );

    const loading = loadingClans;

    return {
        loading,
        allClans: Array.isArray(clans) ? clans : [],
    };
}
